import { configureStore } from "@reduxjs/toolkit";
import CommonHelperSlice from "./frontend/CommonHelperSlice";
// import dashboardSlice from "./admin/dashboardSlice";

export default configureStore({
    reducer: {
        user: CommonHelperSlice,
    }
})